import React from "react";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "@material-ui/icons/Info";
import { makeStyles } from "@material-ui/core/styles";

import classes from "./RollMessage.module.css";
//comment
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

function RollMessage(message, meta) {
  const classesPop = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  let modifier = "";
  if (parseInt(meta.modifier) > 0) {
    modifier = "+" + meta.modifier;
  } else if (parseInt(meta.modifier) < 0) {
    modifier = meta.modifier;
  }
  let dice_info = meta.dice.join("+") + modifier;

  let chatMessage = (
    <span className={classes.message__chatMessage}>
      <i>{message+": "}</i>
    </span>
  );

  let emote = "";
  if (meta.emote) {
    emote = meta.emote;
  }
  return (
    <div>
      <div
        className={
          meta.crit
            ? classes.emote__crit
            : meta.crit_fail
            ? classes.emote__critfail
            : ""
        }
      >
        {emote}
      </div>
      <div className={classes.rollMessage}>
        <span>
          {chatMessage}
          <span
            className={
              meta.crit
                ? classes.message__crit
                : meta.crit_fail
                ? classes.message__critfail
                : meta.diceRoll
                ? classes.message__diceRoll
                : ""
            }
          >
            {meta.diceRollValue.toString()}
          </span>
        </span>
        <span className={classes.message__icon}>
          <Typography
            aria-owns={open ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            <InfoIcon />
          </Typography>
          <Popover
            id="mouse-over-popover"
            className={classesPop.popover}
            classes={{
              paper: classesPop.paper,
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography>{dice_info}</Typography>
          </Popover>
        </span>
      </div>
    </div>
  );
}

export default RollMessage;
